// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3HAv6","text":"SelectPayment_text__14kvj","title":"SelectPayment_title__3mrzN","btn":"SelectPayment_btn__34s0T"};